import io from 'socket.io-client';

let current = 1;
export default class CustomWebSocket {
    constructor(url) {
        this.url = url;
        this.id = current++;
        this.readyState = CustomWebSocket.CONNECTING;

        // Emulate WebSocket events
        this.onopen = null;
        this.onclose = null;
        this.onerror = null;
        this.onmessage = null;

        let websocketUrl = url.replace("ws", "http");
        this.socket = io(websocketUrl, {
            transports: ['polling'], // Simulate "not using websocket connection" as requested
            reconnection: false, // Disable auto-reconnect to behave like native WebSocket
        });

        this.socket.on('connect', () => {
            console.log('Connected to middleware, waiting for backend...');
        });

        this.socket.on('backend_connected', () => {
            console.log('Backend connected confirmed');
            this.readyState = CustomWebSocket.OPEN;
            if (this.onopen) {
                this.onopen({ type: 'open' });
            }
        });

        this.socket.on('disconnect', (reason) => {
            this.socket.disconnect();
            console.log('CustomWebSocket ' + this.id + ' disconnected:', reason);
            if (this.readyState === CustomWebSocket.CLOSED) return;

            this.readyState = CustomWebSocket.CLOSED;
            if (this.onclose) {
                // WebSocket onClose event usually has code, reason, wasClean
                // reason from socket.io might be "transport close", "ping timeout", etc.
                this.onclose({ 
                    type: 'close', 
                    code: 1000, 
                    reason: reason,
                    wasClean: reason === 'io client disconnect' 
                });
            }
        });

        this.socket.on('connect_error', (error) => {
            console.error('CustomWebSocket ' + this.id + ' connection error:', error);
            this.socket.disconnect();
            if (this.onerror) {
                this.onerror({ type: 'error', error: error });
            }

            if (this.readyState === CustomWebSocket.CLOSED) return;

            // Native WebSocket triggers onClose after onError if connection fails
            this.readyState = CustomWebSocket.CLOSED;
            if (this.onclose) {
                this.onclose({ 
                    type: 'close', 
                    code: 1006, // 1006 indicates abnormal closure (e.g. connection failure)
                    reason: error.message || 'Connection failed',
                    wasClean: false 
                });
            }
        });

        this.socket.on('message', (data) => {
            console.log('CustomWebSocket received message:', data);
            if (this.onmessage) {
                let blobData = data;
                // Ensure data is a Blob as expected by the consumer
                if (!(data instanceof Blob)) {
                    if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) {
                        blobData = new Blob([data]);
                    } else if (typeof data === 'object') {
                         // Attempt to serialize object to JSON blob if it's not binary
                         try {
                             blobData = new Blob([JSON.stringify(data)]);
                         } catch (e) {
                             console.error("Failed to convert message to Blob", e);
                         }
                    } else {
                        blobData = new Blob([String(data)]);
                    }
                }
                this.onmessage({ data: blobData });
            }
        });
    }

    send(data) {
        console.log('Sending message to middleware:', data);
        if (this.readyState === CustomWebSocket.OPEN) {
            // socket.io usually handles objects/strings/buffers directly.
            // If data is a typed array or buffer, it sends as binary.
            this.socket.emit('message', data);
        }
    }

    close() {
        this.socket.close();
        this.readyState = CustomWebSocket.CLOSED;
    }
}

CustomWebSocket.CONNECTING = 0;
CustomWebSocket.OPEN = 1;
CustomWebSocket.CLOSING = 2;
CustomWebSocket.CLOSED = 3;



// WEBPACK FOOTER //
// ./static/js/proto/art/CustomWebSocket.js